module.exports = "## Easy Image Resize\r\n\r\nUpload and choose a new size for your image. You can choose a percentage of the original size or specify exact pixel dimensions you want to resize your image to. Resizing your images allows them to be displayed without stretching.\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/containers/ImageResize/easy-image-resize.md
// module id = 1175
// module chunks = 0